
import { RevCheckbox } from '@ds/components/Checkbox'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import { RevTag } from '@ds/components/Tag'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'

import { MODAL_NAMES } from '@config/constants'
import { trackClick } from '@tracking/events'

import PrepaidPlanModal from '../Modals/PrepaidPlanModal'

import translations from './MobilePlans.translations'
import PlanTag from './PlanTag.vue'

export default {
  components: {
    IconCheckInCircle,
    PrepaidPlanModal,
    RevCheckbox,
    RevLink,
    RevTag,
  },
  props: {
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    translations: () => translations,
    planTag: () => PlanTag,
  },
  methods: {
    openPrepaidPlanModal() {
      openModal(MODAL_NAMES.PRODUCT.PREPAID_PLAN)
    },
    handleChange(event) {
      this.$emit('select', event.target.checked)

      trackClick({
        name: 'prepaid_plan',
        page_type: this.$route.name,
        value: event.target.checked ? 'activate' : 'deactivate',
        zone: 'mobile_plan',
      })
    },
  },
}
